import { SpecialOfferProps, stateStatusType } from './actionType';

export interface FetchSpecialOfferState {
  isLoading: boolean;
  error: string | null;
  specialOffer: SpecialOfferProps[] | [];
  status: stateStatusType | null;
}
export interface GenericSpecialOfferStateProps {
  isLoading: boolean;
  status: stateStatusType | null;
  error: string | null;
}

export const initialSpecialOfferState: FetchSpecialOfferState = {
  isLoading: false,
  error: null,
  specialOffer: [],
  status: null,
};
export const initialGenericSpecialOfferState: GenericSpecialOfferStateProps = {
  isLoading: false,
  error: null,
  status: null,
};

export interface SpecialOfferState {
  specialOfferState: FetchSpecialOfferState;
  genericSpecialOfferState: GenericSpecialOfferStateProps;
}

export const initialState: SpecialOfferState = {
  specialOfferState: initialSpecialOfferState,
  genericSpecialOfferState: initialGenericSpecialOfferState,
};
